import { render, staticRenderFns } from "./ReportDialog.vue?vue&type=template&id=79870e51"
import script from "./ReportDialog.vue?vue&type=script&lang=js"
export * from "./ReportDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports